import React, { useContext, useEffect } from 'react';
import { WardrobesConfigsContext } from '../../contexts/WardrobesConfigsContext';
import { ActiveWardrobeContext } from '../../contexts/ActiveWardrobeContext';
import { ConfiguratorModeContext } from 'contexts/ConfiguratorModeContext';
import { PriceContext } from '../../contexts/PriceContext';
import { EventsDataContext } from '../../contexts/EventsDataContext';
import FixedContainer from '../common/FixedContainer';
import ShareButton from '../buttons/ShareButton';
import Button from '../buttons/Button';
import PropTypes from 'prop-types';
import LinkButton from '../buttons/LinkButton';
import calculatePrice from '../../helpers/calculatePrice';
import Currency from 'react-currency-formatter';
import ReactTooltip from 'react-tooltip';

const SummaryBar = props => {
  const { btnText, btnLink, btnIcon, share, btnFunction, propClass } = props;
  const { wardrobesConfigs } = useContext(WardrobesConfigsContext);
  const { currentConfiguratorMode } = useContext(ConfiguratorModeContext);
  const { activeWardrobe } = useContext(ActiveWardrobeContext);
  const { setPrice, price } = useContext(PriceContext);
  const { optionsVisibility } = useContext(EventsDataContext);

  useEffect(() => {
    if (currentConfiguratorMode === 8) {
      setPrice(calculatePrice(wardrobesConfigs));
    } else {
      setPrice(calculatePrice(wardrobesConfigs[activeWardrobe]));
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [activeWardrobe, currentConfiguratorMode, wardrobesConfigs]);
  return (
    <FixedContainer classed={!optionsVisibility.share ? 'z-index' : ''}>
      <div className="summary-bar">
        <div className="summary-bar__prices">
          {price.actual < price.regular && (
            <span className="summary-bar__price summary-bar__price--old">
              <del>
                <Currency quantity={price.regular} currency="PLN" />
              </del>
            </span>
          )}
          <span className="summary-bar__price">
            <Currency quantity={price.actual} currency="PLN" />
          </span>
          <div
            className={`summary-bar__price--last-promotion ${
              price.actual < price.regular ? '' : 'hide'
            }`}>
            {Number.isNaN(price.omnibus) ? null : (
              <>
                Najniższa cena z 30 dni: <Currency quantity={price.omnibus} currency="PLN" />
              </>
            )}
            <span
              className="icon-help-circle icon"
              data-tip="Najniższa cena z ostatnich 30 dni <br>od rozpoczęcia aktualnej promocji"></span>
          </div>
        </div>

        {share && <ShareButton {...props} />}
        {btnLink ? (
          <LinkButton text={btnText} link={btnLink} icon={btnIcon} propClass={propClass} />
        ) : (
          <Button text={btnText} icon={btnIcon} click={btnFunction} propClass={propClass} />
        )}
      </div>
      <ReactTooltip type="light" multiline className="summary-tooltip" />
    </FixedContainer>
  );
};

SummaryBar.propTypes = {
  btnText: PropTypes.string.isRequired,
  btnLink: PropTypes.string,
  btnIcon: PropTypes.bool,
  share: PropTypes.bool,
  realizationTime: PropTypes.bool,
  propClass: PropTypes.string,
};

export default SummaryBar;
